import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuthActions } from 'authOld/hooks';
import { IResendEmailVerificationLinkForm } from 'authOld/types';
import { ApiStatuses, NotificationPosition } from 'coreOld/enums';
import { useNotification } from 'coreOld/hooks/useNotification';

import ResendEmailVerificationLinkFormView from './ResendEmailVerificationLinkFormView';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  goBack: () => void;
}

const ResendEmailVerificationLinkForm = ({ isOpen, onClose, goBack }: IProps) => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const { t } = useTranslation();
  const { clearNotification, showNotification } = useNotification();
  const { resendEmailVerificationLink } = useAuthActions();

  useEffect(() => {
    setIsSubmitted(false);
  }, [isOpen]);

  const onSubmit = () => async (data: IResendEmailVerificationLinkForm) => {
    await resendEmailVerificationLink(data);

    showNotification({
      message: t('messageResendEmailInfo'),
      type: ApiStatuses.INFO,
      position: NotificationPosition.MODAL,
    });

    setIsSubmitted(true);
  };

  const handleGoBack = () => {
    if (isSubmitted) {
      clearNotification();
      setIsSubmitted(false);

      return;
    }

    goBack();
  };

  return (
    <ResendEmailVerificationLinkFormView
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      isSubmitted={isSubmitted}
      goBack={handleGoBack}
    />
  );
};

export default ResendEmailVerificationLinkForm;
